/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCamera: {
  name: 'camera';
  data: string;
} = {
  name: 'camera',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 1.5a.5.5 0 0 0-.5.5v2.5h5V2a.5.5 0 0 0-.5-.5H6ZM4.5 2v2.5H2A1.5 1.5 0 0 0 .5 6v8A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 14 4.5h-2.5V2A1.5 1.5 0 0 0 10 .5H6A1.5 1.5 0 0 0 4.5 2ZM5 5.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h3Zm.5 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM8 6.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
